var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"cmpt":"StringValueRow"}},[_c('Label',{attrs:{"styling":_vm.labelStyling,"label":_vm.C.get(_vm.label)},on:{"click":function($event){return _vm.emitClick()}}}),_c('Value',{attrs:{"styling":_vm.valueStyling,"value":_vm.CU.unescape(_vm.value)},on:{"click":function($event){return _vm.emitClick()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }